module.exports = __webpack_public_path__ + "static/media/helsinki-9.ea0cc3f8.jpg";